import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Solutions.css";

const achievements = [
  {
    number: "700+",
    label: "Projects Completed",
    icon: "https://img.icons8.com/fluency/96/completed-task.png",
    image: "https://media.istockphoto.com/id/927805948/photo/success-and-team-work-concept-group-of-business-partners-with-raised-up-hands-in-light-modern.jpg?s=612x612&w=0&k=20&c=QgOfquVMp0GKbkq2X5H_Z4CUUhmUpQhQtlJN-mSTcV8=",
  },
  {
    number: "100+",
    label: "Happy Clients",
    icon: "https://img.icons8.com/fluency/96/happy.png",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=600&q=80",
  },
  {
    number: "100+",
    label: "Skilled Creative Minds",
    icon: "https://img.icons8.com/fluency/96/conference-call.png",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80",
  },
  {
    number: "10+",
    label: "Years of Experience",
    icon: "https://img.icons8.com/fluency/96/briefcase.png",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=600&q=80",
  },
];

const Solutions = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="achievement-section">
      <div className="parallax-background"></div>
      <div className="overlay-glass">
        <div className="achievement-container" data-aos="fade-up">
          <p className="achievement-subtitle">ACHIEVEMENTS</p>
          <h2 className="achievement-heading">We are Amplifying Your Business Prosperity</h2>

          <div className="achievement-stats">
            {achievements.map((item, idx) => (
              <div
                className="achievement-card"
                key={idx}
                data-aos="zoom-in"
                data-aos-delay={idx * 300}
              >
                <div className="image-bg">
                  <img src={item.image} alt={item.label} />
                </div>
                <div className="icon-circle">
                  <img src={item.icon} alt={item.label} />
                </div>
                <h3>{item.number}</h3>
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;


// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "./Solutions.css";

// const achievements = [
//   {
//     number: "350+",
//     label: "Projects Completed",
//     icon: "https://img.icons8.com/fluency/96/completed-task.png",
//   },
//   {
//     number: "150+",
//     label: "Happy Clients",
//     icon: "https://img.icons8.com/fluency/96/happy.png",
//   },
//   {
//     number: "100+",
//     label: "Team Members",
//     icon: "https://img.icons8.com/fluency/96/conference-call.png",
//   },
//   {
//     number: "10+",
//     label: "Years of Experience",
//     icon: "https://img.icons8.com/fluency/96/briefcase.png",
//   },
// ];

// const Solutions = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1200, once: true });
//   }, []);

//   return (
//     <section className="vibrant-achievement-section">
//       <div className="background-animations">
//         <div className="blob blob1"></div>
//         <div className="blob blob2"></div>
//         <div className="blob blob3"></div>
//       </div>

//       <div className="container" data-aos="fade-up">
//         <p className="vibrant-subtitle">ACHIEVEMENTS</p>
//         <h2 className="vibrant-title">We Empower Brands With Results</h2>

//         <div className="achievement-grid">
//           {achievements.map((item, index) => (
//             <div className="vibrant-card" key={index} data-aos="zoom-in" data-aos-delay={index * 200}>
//               <div className="vibrant-icon-glow">
//                 <img src={item.icon} alt={item.label} />
//               </div>
//               <h3 className="count">{item.number}</h3>
//               <p>{item.label}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Solutions;
